import { Component, OnInit } from '@angular/core';
import { AppState } from '../../Store/app.state/app.state';
import { Store } from '@ngxs/store';
import { APPLICATION_MODE, IAppConf, SCENE_MODE } from '../../Store/app.state/app.model';
import { Observable } from 'rxjs';
import { SceneContainer } from './scene.container/scene.container';

@Component({
    selector: 'ins-content-container',
    templateUrl: './content.container.html',
    styleUrls: ['./content.container.scss'],
    imports: [SceneContainer]
})
export class ContentContainer implements OnInit {

  selectedMode$: Observable<SCENE_MODE>;
  public sceneMode: SCENE_MODE;

  pressedPanelName$: Observable<string>;
  public openedPanel: string;

  appConf$: Observable<IAppConf>;
  public appConf: IAppConf;
  public APPLICATION_MODES: any = APPLICATION_MODE;
  constructor(private store: Store) {
    this.selectedMode$ = this.store.select(AppState.getSelectedMode);
    this.pressedPanelName$ = this.store.select(AppState.getOpenedPanel);
    this.appConf$ = this.store.select(AppState.getAppConf);
    this.appConf$.subscribe( (appConf: IAppConf) => {
      this.appConf = appConf;
    });

    this.selectedMode$.subscribe((mode: SCENE_MODE) => {
      this.sceneMode = mode;
    });
    this.pressedPanelName$.subscribe((name: string) => {
      this.openedPanel = name;
    });
  }

  ngOnInit(): void {
  }

}
